import { Redirect, useLocalSearchParams } from 'expo-router';
import { useMemo } from 'react';

import { ScreenMenuItemWithQuery } from '@fhs/menu/src/screens/screen-menu-item';
import { selectors, useAppSelector } from '@fhs-legacy/frontend/src/state/global-state';
import { useOrderContext } from '@fhs-legacy/frontend/src/state/order';
import { isSectionRoute, routes } from '@fhs-legacy/frontend/src/utils/routing';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function MenuItemPage() {
  const { slug, rewardBenefitId, rewardId, isEdit } = useLocalSearchParams<{
    slug: string;
    rewardBenefitId: string;
    rewardId: string;
    isEdit: string;
  }>();

  const isEditBoolean = isEdit === 'true';

  const sectionRoute = isSectionRoute(`/menu/${slug}`);
  const { getCurrentCartEntry } = useOrderContext();
  const appliedLoyaltyRewards = useAppSelector(selectors.loyalty.selectAppliedLoyaltyRewards);

  const hasAppliedRewards = useMemo(
    () => (isEditBoolean ? !!appliedLoyaltyRewards[getCurrentCartEntry()?.cartId] : false),
    [isEditBoolean, appliedLoyaltyRewards, getCurrentCartEntry]
  );

  const isReward = Boolean(rewardBenefitId || rewardId) || hasAppliedRewards;

  // Section routes are not supported in new menu flow, redirect to menu page
  if (sectionRoute && !isReward) {
    return <Redirect href={routes.menu} />;
  }

  return <ScreenMenuItemWithQuery />;
}
